
import React, { Component } from 'react';


class Validate extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    HasInvalidEmail() {
        const value=this.props.value;
        if (!Validate.IsValidEmail(value)) return true;
        return false;
    }
    HasInvalidIban() {
        const value=this.props.value;
        if (!Validate.IsValidIban(value)) return true;
        return false;
    }
    HasInvalidCode() {
        const value=this.props.value;
        if (!Validate.IsValidCode(value)) return true;
        return false;
    }
    HasMinLength() {
        const value=this.props.value;
        if (!value) return;
        if (value.length<this.props.minLength) return false;
        return true;
    }
    HasInvalidPhoneNumber() {
        const value=this.props.value;
        if (!Validate.IsValidPhoneNumber(value)) return true;
        return false;
    }

    static IsValidEmail(email) {
        // eslint-disable-next-line
        if (!email || !email.split) return false;
        if (email.indexOf(" ")>-1) return false;
        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9\-]+)?[\@][a-z\-]{2,25}[\.][a-z]{2,5}/g;
        return pattern.test(email);
    }

    static IsValidPhoneNumber(number) {
        if (!number || !number.length) return true;

        // make sure that all characters are numbers, check for valid mobile number
        const pattern = /^[0-9]*$/g;
        if (!pattern.test(number)) return false;

        // length must be between 8 and 14 digits
        if (number.length<8 || number.length>14) return false;

        // check that a mobile number must have 10 digits
        if (number.indexOf("06")===0 && number.length!==10)  return false;

        return true;

    }

    static IsValidCode(code) {
        if (!code || !code.length) return true;
        if (code.length<3 || code.length>8) return false;
        const pattern = /^[0-9A-B#]{4,8}$/g;
        return pattern.test(code);
    }

    static IsValidIban = (value) => {
        if (value===null) return false;
        let rearrange =
            value.substring(4, value.length)
            + value.substring(0, 4);
        let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');
        let alphaMap = {};
        let number = [];
    
        alphabet.forEach((value, index) => {
            alphaMap[value] = index + 10;
        });
    
        rearrange.split('').forEach((value, index) => {
            number[index] = alphaMap[value] || value;
        });
    
        return Validate.modulo(number.join('').toString(), 97) === 1;
    }

    

    
    static modulo = (aNumStr, aDiv) => {
        var tmp = "";
        var i, r;
        for (i = 0; i < aNumStr.length; i++) {
            tmp += aNumStr.charAt(i);
            r = tmp % aDiv;
            tmp = r.toString();
        }
        return tmp / 1;
    }


    render() {
        
        return <React.Fragment>
            {this.props.type==="email" && this.HasInvalidEmail() && this.props.value!=="" && <div className="text-danger">
            Email adres is (mogelijk) ongeldig
            </div>
            }
            {this.props.type==="iban" && this.HasInvalidIban() && this.props.value!=="" && <div className="text-danger">
            IBAN nummer is ongeldig
            </div>
            }
            {this.props.type==="code" && this.HasInvalidCode() && this.props.value!=="" && <div className="text-danger">
            Ongeldige code
            </div>
            }
            {this.props.type==="minLength" && !this.HasMinLength() && this.props.value!=="" && <div className="text-danger">
            Voer minimaal {this.props.minLength} karakters in
            </div>
            }
            {this.props.type==="phone" && this.HasInvalidPhoneNumber() && this.props.value!=="" && <div className="text-danger">
            Geen geldig telefoon nummer, gebruik alleen cijfers
            </div>
            }
        </React.Fragment>
    
    }
}

export default Validate;